<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <header_promotion_name header="แก้ไขโปรโมชั่น" :img_header="header_image" :promotion_code="header_list.promotion_code" link_back="stock/promotion_stock/promotionexp"/>
      <v-form ref="update" @submit.prevent="update_promotion">
        <v-card elevation="6">
          <div class="grid-half">
            <div class="grid-list">
              <div class="ml-3 mt-3 mb-3 mr-2">
                <v-text-field color="#86bc3a" label="ชื่อโปรโมชั่น" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกชื่อโปรโมชั่น']" required v-model="header_list.promotion_name" outlined></v-text-field>
              </div>
              <div class="ml-3 mt-3 mb-3 mr-2">
                <v-text-field color="#86bc3a" label="ราคาขายต่อหน่วย" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกราคาขายต่อหน่วย']" required @keypress="onlyNumber($event, header_list.price_per_set)" v-model="header_list.price_per_set" outlined></v-text-field>
              </div>
              <div class="ml-3 mt-3 mr-2">
                <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable color="#86bc3a" v-model="date" label="วันที่สิ้นสุดโปรโมชั่น (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณาระบุวันที่สิ้นสุดโปรโมชั่น']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(dateEN)" v-model="dateEN" :min="start_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectDate()">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_date = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
            <div></div>
          </div>
          <div class="grid_full">
            <div class="ml-3 mr-2">
              <v-textarea color="#86bc3a" label="รายละเอียด" hide-details="auto" v-model="header_list.note" outlined></v-textarea>
            </div>
          </div>
          <div class="mt-2 ma-4">
            <headerexpire_promotion :product_name="detail_list.product_name" expire_product="Coming Soon" name="จำนวนรวม" :unit="header_list.quantity" :unit_name="detail_list.unit_name"/>
          </div>
          <div class="pa-2">
            <v-card-title>
              <v-text-field color="#86bc3a" v-model="search" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data_list" :search="search" mobile-breakpoint="0" hide-default-footer>
              <template v-slot:item="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.lot_no }}</td>
                  <td>{{ diff_dateTH(dataDetail.item.date_expired) }}</td>
                  <td>{{ dataDetail.item.quantity }}</td>
                  <td>{{ dataDetail.item.supplier_name }}</td>
                  <td>{{ format_Price(dataDetail.item.cost) }}</td>
                </tr>
              </template>
            </v-data-table>
            <div v-if="date_raw > date_now" class="pa-4 pt-6">
              <usercreate_promotion :user="header_list.user_name" :create_time="header_list.created_date" :status="header_list.status"/>
            </div>
            <div v-else class="pa-4 pt-6">
              <usercreate_promotion :user="header_list.user_name" :create_time="header_list.created_date" :status="0"/>
            </div>
          </div>
          <div class="text-center mt-4 pb-4">
            <v-btn height="45" class="white--text grad-success-bg btn_size" type="submit">บันทึกข้อมูล</v-btn>
          </div>
        </v-card>
      </v-form>
    </div>
  </div>
</template>

<script>
import header_promotion_name from "@/components/admin/stock/storage_promotion/header_promotion/header_promotion_name";
import headerexpire_promotion from "@/components/admin/stock/storage_promotion/header_promotion/headerexpire_promotion";
import usercreate_promotion from "@/components/admin/stock/storage_promotion/header_promotion/usercreate_promotion";
import HeadeImage from "@/assets/formnew.png"
import {diffDateTH, formatPrice, minDate, onlyForCurrency} from "@/js/handler";
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_edit",
  components: {
    usercreate_promotion,
    headerexpire_promotion,
    header_promotion_name
  },
  data() {
    return {
      header_image: HeadeImage,
      loading_page: false,
      search: null,
      menu_date: false,
      date: '',
      dateEN: '',
      date_now: null,
      date_raw: null,
      start_date: this.min_Date(),
      headers: [
        {
          text: 'ล็อต',
          value: 'lot_no',
          fixed: true,
          width: '120px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '160px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ราคาต้นทุน/หน่วย',
          value: 'cost',
          fixed: true,
          width: '200px',
        },
      ],
      header_list: [],
      detail_list: [],
      data_list: [],
    }
  },
  methods: {
    get_date() {
      let date_today = new Date();
      let day = date_today.getDay();
      let month = date_today.getMonth() + 1;
      let year = date_today.getFullYear();
      if (month < 10){
        month = '0'+ month
      }
      if (day < 10){
        day = '0'+ day
      }
      this.date_now = year + '-' + month + '-' + day
    },
    diff_dateTH: function (value) {
      return diffDateTH(value)
    },
    min_Date: function () {
      return minDate()
    },
    format_Price: function(value) {
      return formatPrice(value)
    },
    onlyNumber: function(evt, number) {
      return onlyForCurrency(evt, number)
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'-'+month+'-'+year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    getDetails() {
      this.loading_page = true
      HTTP.post('/inventory/promotions/expireds/get', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.head
          if (res.data.head.end_date !== null) {
            this.date_raw = res.data.head.end_date
            this.date = res.data.head.end_date
            this.diffDateTH(this.date)
          }
          else {
            this.date = ''
          }
          this.detail_list = res.data.detail
          this.data_list = res.data.lists
        }
      })
    },
    update_promotion() {
      if (this.$refs.update.validate) {
        Swal.fire({
          title: 'ต้องการบันทึกข้อมูลหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            HTTP.post('/inventory/promotions/expireds/update', {
              user_id: this.$store.state.userDetail.id,
              user_name: this.$store.state.userDetail.name,
              id: this.header_list.id,
              promotion_name: this.header_list.promotion_name,
              price_per_set: this.header_list.price_per_set,
              end_date: this.diffDateEN(),
              note: this.header_list.note,
            }).then((res) => {
              if (res.data.success === true) {
                Swal.fire({
                  title: 'แก้ไขข้อมูลสำเร็จ !',
                  icon: 'success',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                }).then((res) => {
                  if (res.isConfirmed === true) {
                    this.$router.push('/stock/promotion_stock/promotionexp')
                  }
                  else {
                    this.$router.push('/stock/promotion_stock/promotionexp')
                  }
                })
              }
            })
          }
        })
      }
    },
  },
  mounted() {
    this.get_date()
    this.getDetails()
  }
}
</script>

<style scoped>
.btn_size {
  font-size: 18px;
}
.grid-half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid-list {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
@media only screen and (max-width: 1100px) {
  .grid-half {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .grid-half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid-list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
